export function common() {
	function scrollToAnchor() {
		const hash = window.location.hash;

		if (hash && hash.length > 1) {
			const anchorId = hash.substring(1);

			const targetElement = document.getElementById(anchorId);

			if (targetElement) {
				targetElement.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
					inline: 'nearest'
				});
			}
		}
	}

	document.addEventListener('DOMContentLoaded', () => {setTimeout(scrollToAnchor, 100)})
	window.addEventListener('hashchange', scrollToAnchor)

	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll('.js-toggle-trigger').forEach((trigger) => {
			trigger.addEventListener('click', () => {
				let toggleEl = null;

				const targetSelector = trigger.getAttribute('data-target');
				if (targetSelector) {
					toggleEl = document.querySelector(targetSelector);
				}

				if (!toggleEl) {
					const parentContainer = trigger.closest('[class*="block-"], .container, .section, div');
					if (parentContainer) {
						toggleEl = parentContainer.querySelector('.js-toggle');
					}
				}

				if (!toggleEl) {
					let nextSibling = trigger.nextElementSibling;
					while (nextSibling) {
						if (nextSibling.classList.contains('js-toggle')) {
							toggleEl = nextSibling;
							break;
						}
						nextSibling = nextSibling.nextElementSibling;
					}
				}

				if (!toggleEl) return;

				const isActive = toggleEl.classList.toggle('active');
				const btnTextEl = trigger.querySelector('.btn-text');

				if (btnTextEl) {
					const openedText = btnTextEl.getAttribute('data-opened-text') || btnTextEl.textContent;
					const closedText = btnTextEl.getAttribute('data-closed-text') || btnTextEl.textContent;
					btnTextEl.textContent = isActive ? openedText : closedText;
				}

				trigger.setAttribute('aria-expanded', String(isActive));
				toggleEl.setAttribute('aria-hidden', String(!isActive));
			});
		});


	});
}
